let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2sS5p")).then(() => parcelRequire('dyRg0'));